export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const UPDATE_RSS_SUCCESS = 'UPDATE_RSS_SUCCESS';
